(function () {
  if (window.__buttonPopupInitialized) return;
  window.__buttonPopupInitialized = true;

  function openPromotionPopup() {
    const popup = document.querySelector('promotion-popup.promotionPopup');
    if (!popup) return false;

    if (typeof popup.setOpenPopup === 'function') {
      popup.setOpenPopup(0);
    } else {
      popup.setAttribute('open', 'true');
      document.body.classList.add('overflow-hidden');
      document.documentElement.setAttribute('scroll-lock', '');
    }

    return true;
  }

  var popupContentCache = {};

  function loadPopupContent(drawer, url) {
    const container = drawer.querySelector('[data-popup-page-content]');
    if (!container || !url || container.dataset.loaded === 'true') return;

    const loading = drawer.querySelector('[data-popup-loading]');

    function done(html) {
      container.innerHTML = html;
      container.dataset.loaded = 'true';
      if (loading) loading.remove();
    }

    if (popupContentCache[url]) {
      done(popupContentCache[url]);
      return;
    }

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load page');
        return response.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const main = doc.querySelector('#MainContent');
        if (!main || !main.innerHTML.trim()) throw new Error('Empty page content');
        popupContentCache[url] = main.innerHTML;
        done(main.innerHTML);
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-button-popup]');
    if (!button) return;

    const type = button.getAttribute('data-button-popup');

    if (type === 'newsletter') {
      event.preventDefault();

      if (!openPromotionPopup()) {
        console.warn('[Button popup] No "Promotion popup" section found. Add one to the Popups group.');
      }

      return;
    }

    if (type === 'page') {
      event.preventDefault();

      const target = button.getAttribute('data-popup-target');
      const url = button.getAttribute('data-popup-url');
      const drawers = target ? document.querySelectorAll(target) : [];
      const drawer = drawers.length ? drawers[drawers.length - 1] : null;

      if (drawer && typeof drawer.open === 'function') {
        drawer.open(button);
        loadPopupContent(drawer, url);
      } else if (url) {
        window.location.href = url;
      }
    }
  });
})();